import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { FigmaAPI, figmaApiRef } from './api/FigmaApi';

export const figmaPlugin = createPlugin({
  id: 'figma',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: figmaApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, configApi, fetchApi }) => {
        return new FigmaAPI({
          discoveryApi,
          configApi,
          fetchApi,
        });
      },
    }),
  ],
});

export const FigmaPage = figmaPlugin.provide(
  createRoutableExtension({
    name: 'FigmaPage',
    component: () =>
      import('./components/FigmaUpdateInfoCard').then(
        m => m.FigmaUpdateInfoCard,
      ),
    mountPoint: rootRouteRef,
  }),
);
